import { Component, OnDestroy } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

interface IRouterLinkParams extends ICellRendererParams {
  editTooltip: string;
  viewTooltip: string;
}

@Component({
  selector: "ag-grid-delete-row-renderer",
  template: `<a class="circle" *ngIf="canDelete" (click)="remove()">
    <em class="material-icons" title="Remove">delete</em>
  </a>`,
  standalone: false,
})
export class DeleteRowRenderer implements ICellRendererAngularComp, OnDestroy {
  canDelete: boolean;
  params: IRouterLinkParams;

  agInit(params: IRouterLinkParams): void {
    this.params = params;
    this.canDelete = this.params.data.canDelete;
  }
  remove() {
    this.params.context.parent.remove(this.params.data);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
